import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField
} from "@mui/material";
import { doc, setDoc, updateDoc } from "firebase/firestore";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { db } from "../../api/firebase";
import { nbfRawMetarial, nbfSupplier } from "../../api/restApi";
import { EncodeLevel3Code } from "../../components/Accounts/Account/HelperClass";
import { setSupplier, supplierData } from "../../store/reducer/supplierSlice";
import { saveLevel3 } from "../../utils/endPoints";
import { useAppDispatch, useAppSelector } from "../../utils/hooks";
import SupplierTable from "./Tables/SupplierTable";
import { CreateBillModal } from "./components/createBillModal";

const Suppliers = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [subtractModal, setSubtractModal] = useState(false);
  const [itemCategory, setItemCategory] = useState([]);
  const { supplier } = useAppSelector(supplierData);
  const level_3 = useAppSelector((state) => state.accountLevels.level3);
  const [tempAutoCompleteValue, setTempAutoCompleteValue] = useState([]);
  const dispatch = useAppDispatch();
  const collectionName = "Supplier";

  const ItemInfo = async () => {
    let supplier = await nbfSupplier();
    //console.log(supplier)
    dispatch(setSupplier(supplier));
  };


  useEffect(() => {
    ItemInfo();
  }, []);

  const handleItem = async () => {
    let items = await nbfRawMetarial();
    console.log(items);
    const addItemArray = items.map((item) => {
      return {
        label: item.name,
        value: item.id,
      };
    });
    setItemCategory([...addItemArray]);
  };
  useEffect(() => {
    handleItem();
  }, []);

  const handleCreateNewRow = async (values) => {
    try {
      if (!values || Object.keys(values).length === 0) {
        alert("Please enter valid data");
        return;
      }

      // Save the main data (e.g., contact person) to the database
     

      // let tempArray = level_3.filter(function (el) {
      //   return el.fullcode.startsWith("10-001");
      // });
      const code = EncodeLevel3Code(supplier.length + 1);
      console.log(code);

      let cust = {
        ...values,
        type: "SUPPLIER",
        freeze: "NO",
        // customer_id,
        // description: d.name_english,
        l1code: "10",
        l2code: "10-001",
        code: code,
        fullcode: "10-001-" + code,
        contact: "234",
      };
      values.id = cust.fullcode;
      const docRef = await setDoc(doc(db, collectionName,values.id), values);
      toast.success("Successfully add new item !", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
       cust = {
        ...cust,
        debit: values.payable >= 0 ?  values.payable : "",
        credit:  values.payable < 0 ?  values.payable : "",
        amount: Math.abs( values.payable),
        transactionType:  values.payable >= 0 ? "Debit" : "Credit",
      };
      let res = await saveLevel3(cust.fullcode, cust);

      ItemInfo();
    } catch (error) {
      console.log(error);
      toast.error("Failed to add new item !", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
  };

  const handleSaveRowEdits = async ({ exitEditingMode, row, values }) => {
    console.log(row, values);
    try {
      let id = row.getValue("id").toString();
      await updateDoc(doc(db, collectionName, id), values);

      toast.success("Successfully update  item !", {
        position: toast.POSITION.BOTTOM_CENTER,
      });

      ItemInfo();
    } catch (error) {
      toast.error("Failed to  update  item!", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
    exitEditingMode(); //required to exit editing mode and close modal
    // }
  };

 
  const columns = useMemo(() => [
    {
      accessorKey: "id",
      header: "ID",
      enableColumnOrdering: false,
      enableEditing: false, //disable editing on this column
      enableSorting: false,
      size: 80,
    },
    {
      accessorKey: "name",
      header: "Supplier_Name",
      size: 140,
    },
    {
      accessorKey: "payable",
      header: "Payable",
      size: 140,
      enableEditing: false,
    },
    {
      accessorKey: "address",
      header: "Address",
      size: 140,
    },
    {
      accessorKey: "phone",
      header: "Phone",
      size: 140,
    },
    {
      accessorKey: "whatsapp",
      header: "whatsapp",
      size: 140,
    },
    {
      accessorKey: "contact_Person",
      header: "Contact Person",
      size: 140,
    },
    {
      accessorKey: "items",
      header: "Items",
      size: 140,
      // editVariant: 'select',
      Cell: ({ cell }) => {
        let dataArray = cell.getValue()?.map((item) => item.label);
        return dataArray?.join(", ");
      },

      // editSelectOptions: itemCategory,
      Edit: ({ cell, column, row, table, onChange }) => {
        setTempAutoCompleteValue(cell.getValue());
        table.setEditingRow(row);
        return (
          <Autocomplete
            options={itemCategory}
            value={row._valuesCache["items"] || null}
            onChange={(_, value) => {
              row._valuesCache["items"] = value;
              row.toggleSelected(row._valuesCache["items"]);
            }}
            multiple
            renderInput={(params) => <TextField {...params} label="Item " />}
          />
        );
      },
    },
  ]);

  return (
    <>
      <Stack spacing={4} marginX={4} mt={1} mb = {3}>
        <SupplierTable
          setCreateModalOpen={setCreateModalOpen}
          setSubtractModalOpen={setSubtractModal}
          tableData={supplier}
          handleSaveRowEdits={handleSaveRowEdits}
          columns={columns}
          csvFileName="supplier"
        ></SupplierTable>
      </Stack>
      <AddSupplierModal
        columns={columns}
        open={createModalOpen}
        onClose={() => setCreateModalOpen(false)}
        onSubmit={handleCreateNewRow}
        itemCategory={itemCategory}
      />
      <CreateBillModal
        supplier={supplier}
        columns={columns}
        open={subtractModal}
        onClose={() => setSubtractModal(false)}
        itemCategory={itemCategory}
      />
    </>
  );
};

//example of creating a mui dialog modal for creating new rows
export const AddSupplierModal = ({
  open,
  columns,
  onClose,
  onSubmit,
  itemCategory,
}) => {
  const [values, setValues] = useState({});
  const [selectedItems, setSelectedItems] = useState([]);
  const buttonRef = useRef(null);

  const handleSubmit = async () => {
    if (buttonRef.current && !buttonRef.current.disabled) {
      buttonRef.current.disabled = true;
      // Perform the action
      // After the action is complete, reset buttonRef.current.disabled to false
    }
  
    // const selectedItemsString = selectedItems.join(", ");

    values.items = selectedItems;
    console.log(values);
    onSubmit(values);
    onClose();
    setValues({});
    setSelectedItems([]);
  };

  useEffect(() => {}, [values]);

  return (
    <Dialog open={open}>
      <DialogTitle textAlign="center">Add Supplier</DialogTitle>
      <DialogContent>
        <form onSubmit={(e) => e.preventDefault()}>
          <Stack
            sx={{
              width: "100%",
              minWidth: { xs: "350px", sm: "500px", md: "400px" },
              gap: "1.5rem",
            }}
          >
            <Box>
              <TextField
                label="supplier_Name"
                type="text"
                sx={{ minWidth: "100%" }}
                value={values.name}
                onChange={(e) => setValues({ ...values, name: e.target.value })}
              />
            </Box>
            <Box>
              <TextField
                label="Payable"
                type="number"
                sx={{ minWidth: "100%" }}
                value={values.payable}
                onChange={(e) =>
                  setValues({ ...values, payable: e.target.value })
                }
              />
            </Box>
            <Box>
              <TextField
                label="Address"
                type="text"
                sx={{ minWidth: "100%" }}
                value={values.address}
                onChange={(e) =>
                  setValues({ ...values, address: e.target.value })
                }
              />
            </Box>
            <Box>
              <TextField
                label="Phone"
                type="number"
                sx={{ minWidth: "100%" }}
                value={values.phone}
                onChange={(e) =>
                  setValues({ ...values, phone: e.target.value })
                }
              />
            </Box>
            <Box>
              <TextField
                label="Whatsapp"
                type="number"
                sx={{ minWidth: "100%" }}
                value={values.whatsapp}
                onChange={(e) =>
                  setValues({ ...values, whatsapp: e.target.value })
                }
              />
            </Box>
            <Box>
              <TextField
                label="Contact Person"
                type="text"
                sx={{ minWidth: "100%" }}
                value={values.contact_Person}
                onChange={(e) =>
                  setValues({ ...values, contact_Person: e.target.value })
                }
              />
            </Box>
            <Box>
              <Autocomplete
                disablePortal
                id="combo-box-demo4"
                sx={{ minWidth: "100%" }}
                options={itemCategory}
                value={selectedItems}
                onChange={(event, tagsList) => {
                  setSelectedItems(tagsList);
                }}
                multiple
                renderInput={(params) => (
                  <TextField {...params} label="Item " />
                )}
              />
            </Box>
          </Stack>
        </form>
      </DialogContent>
      <DialogActions sx={{ p: "1.25rem" }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button color="secondary" onClick={handleSubmit} ref={buttonRef}  variant="contained">
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Suppliers;
